import { useState, useEffect, FC } from 'react'
import { Image } from 'antd'

const LinkPreviewItem: FC<{
 link: RequestInfo
 isSender?: boolean
}> = ({ link, isSender }) => {
 const [previewData, setPreviewData] = useState<{
  title?: string
  description?: string
  image?: string
 } | null>(null)
 const [loading, setLoading] = useState(true)

 useEffect(() => {
  const fetchData = async () => {
   try {
    const response = await fetch(link)
    if (response?.ok) {
     const data = await response.text()
     const parser = new DOMParser()
     const doc = parser.parseFromString(data, 'text/html')
     const title =
      doc.querySelector('meta[property="og:title"]')?.getAttribute('content') ||
      ''
     const description =
      doc.querySelector('meta[name="description"]')?.getAttribute('content') ||
      ''
     const image =
      doc.querySelector('meta[property="og:image"]')?.getAttribute('content') ||
      ''
     const favIcon = doc.querySelector('link[rel="icon"]')?.getAttribute('href')

     setPreviewData({ title, description, image })
    }
    setLoading(false)
   } catch (error) {
    setLoading(false)
   }
  }

  fetchData()
 }, [link])

 if (loading) {
  return <p>Loading...</p>
 }

 if (!previewData) {
  return (
   <div className={isSender ? 'mt-2' : ''}>
    <a
     href={`${link ?? ''}`}
     target="_blank"
     className={`chat-text link-preview__error ${
      isSender ? 'text-white' : 'text-primary'
     }`}
     style={{ overflowWrap: 'break-word' }}
     rel="noreferrer"
    >
     {link as string}
    </a>
   </div>
  )
 }

 return (
  <div
   onClick={() => window.open(link as string, '_blank')}
   className="cursor-pointer"
  >
   <h3
    className={isSender ? 'text-white' : 'text-primary'}
    style={{ fontWeight: 'bold', fontSize: '19px' }}
   >
    {previewData.title}
   </h3>
   {/* <BaseImage ratio="16x9" alt={previewData.title} src={previewData.image} /> */}
   <div className="msg-chat-img">
    {previewData?.image && (
     <Image src={previewData.image} alt={previewData.title} />
    )}
   </div>
   <div className="d-flex pt-3">
    <div>
     <p className={isSender ? 'text-white' : 'text-primary'}>
      {previewData.description}
     </p>
    </div>
   </div>
   <p
    className="mt-3"
    style={{
     color: isSender ? 'white' : '#535353',
     fontSize: '15px',
     overflowWrap: 'break-word',
    }}
   >
    {link as string}
   </p>
  </div>
 )
}

export default LinkPreviewItem
